<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-xl-12 col-lg-12 ">
          <div class="float-left"><h2>Configuración</h2></div>
          <div class="float-right"><router-link  :to="`/catalogos/${schema}/parametro/add`"><button class="btn btn-primary"><i class="fa fa-plus" aria-hidden="true"></i> Agregar</button></router-link></div>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col-xl-12 col-lg-12 ">
          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <div class="input-group-text"><i class="fa fa-search" aria-hidden="true"></i></div>
            </div>
            <input type="text" class="form-control" id="busqueda" name="busqueda" placeholder="Búsqueda" v-model="query">
          </div>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col-xl-12 col-lg-12">
          <a-table
            :columns="colums"
            :dataSource="rowData"
            class="utils__scrollTable"
            :scroll="{ x: '100%' }"
          >
          <span slot="action" slot-scope="row" >
            <router-link  :to="`/catalogos/${schema}/${row.parametro}`"><button type="button" class="btn btn-primary btn-sm"><i class="fa fa-eye" aria-hidden="true"></i></button></router-link>
          </span>
          </a-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const colums = [
  {
    title: 'Parámetro',
    dataIndex: 'parametro',
    key: 'parametro',
    sorter: (a, b) => a.parametro.localeCompare(b.parametro),
  },
  {
    title: 'Acciones',
    width:"100px",
    key: 'action',
    class: 'text-right',
    scopedSlots: {
      customRender: 'action',
    },
  }
]

import utilities from '@/mixins/utilities.js'
export default {
  mixins: [utilities],
  components: {

  },
  data: function () {
    return {
      schema: 'configuracion',
      data:[
        // {"valor": "Contacto", "parametro": "TIPO_CONTACTO"},
        // {"valor": "Región", "parametro": "REGIONES"},
        // {"valor": "Impuesto", "parametro": "IMPUESTOS"},
        // {"valor": "Moneda", "parametro": "MONEDA"},
        // {"valor": "Forma de pago", "parametro": "FORMA_PAGO"},
        // {"valor": "Actividad", "parametro": "TIPO_ACTIVIDAD"},
        // {"valor": "Medio de pago", "parametro": "MEDIOS_DE_PAGO"},
        // {"valor": "Motivo de aprobación", "parametro": "MOTIVO_APROBACION"},
        // {"valor": "Motivo de rechazo", "parametro": "MOTIVO_RECHAZO"},
        // {"valor": "Medio de aprobación", "parametro": "MEDIO_APROBACION"},
        // {"valor": "Rango de comisión", "parametro": "RANGO_COMISION"},
        // {"valor": "Monto", "parametro": "MONTO_COMISION"},
        // {"valor": "Estatus", "parametro": "ESTATUS"},
      ],
      colums,
    }
  },
  created () {
    this.getDataCat().then(data=>{
      console.log(data)
      this.data = data
        .map(i => ({id: i.id, ...i.payload}))
        .reduce((v, c) => { const found = v.find(f => f.parametro === c.parametro); if (!found) { v.push(c) } return v }, [])
        .sort((a, b) => { return a.parametro.localeCompare(b.parametro) })
    });

  },
  computed: {
    rowData() {
      return this.query
        ? this.data.filter(
            (f) =>
              f.parametro.toString().toLowerCase().includes(this.query.toLowerCase()),
          )
        : this.data;
    },
  },
  methods: {
  },
}
</script>
